import { ResourceProps, Show, Tab, TabbedShowLayout, TextField } from 'react-admin';

import { FC } from 'react';
import { NotificationHistory } from 'routes/Notifications';
import { SendNotificationButton } from 'components';

const NotificationShow: FC<ResourceProps> = (props) => {
  return (
    <Show title="Уведомление" {...props}>
      <TabbedShowLayout>
        <Tab label="Об уведомлении">
          <TextField source="id" />
          <TextField label="Название" source="title" />
          <TextField label="Заголовок уведомления" source="notificationTitle" />
          <TextField label="Текст уведомления" source="notificationBody" />
          <TextField label="ID администратора" source="administratorSenderId" />
          <SendNotificationButton />
        </Tab>
        <Tab label="История отправки уведомления">
          <NotificationHistory />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default NotificationShow;
